import "./CourseTimeline.css";

export default function CourseTimeline({ title, days }) {
  return (
    <div className="timeline-box">
      <div className="timeline-content">
        <h3 className="timeline-card-title">{title}</h3>

        <div className="timeline-steps-wrapper">
          {days.map((day, index) => {
            const [dayPart, contentPart] = day.split(": ");
            return (
              <div className="timeline-step-row" key={index}>
                <div className="step-indicator">
                  <div className="step-dot"></div>
                  <div className="step-line"></div>
                </div>
                <div className="step-details">
                  <span className="step-day-number">{dayPart}</span>
                  <p className="step-info-text">{contentPart}</p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}
